import React from 'react';
import styled from 'styled-components';


const BenefitsReel = ({ data }) => {

    
    return (

        <Container addSidePadding={true} shadow={false}>

            {
                data.map((item, index) => {

                    return (
                        <SectionThird key={index}>
                            <BenefitContents>
                                <BenefitTitle>{item.title}</BenefitTitle>
                                <BenefitDescription>{item.description}</BenefitDescription>
                                {/* <BenefitCallOutBox>
                                    <BenefitCallOut>{item.callout}</BenefitCallOut>
                                    <BenefitCallOutSub>{item.calloutsub}</BenefitCallOutSub>
                                </BenefitCallOutBox> */}
                            </BenefitContents>
                           
                        </SectionThird>
                    )
                })
            }
        </Container>

    );
}


export default BenefitsReel;



const Container = styled.div`
    padding-top:50px;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items: stretch;
    align-content:center;
    box-sizing:border-box;
    width:100%;
    gap:30px;
    flex-wrap:wrap;
    z-index:10000;

`


const SectionThird = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    flex-wrap:nowrap;
    align-items:center;
    align-content:center;
    flex: 1;
    color:#fff;
    background: linear-gradient(85deg, rgb(111, 58, 250) 0%, rgb(58, 142, 246) 200%);
    box-shadow: rgba(60, 66, 87, 0.06) 0px 0px 5px 0px, rgba(0, 0, 0, 0.06) 0px 0px 5px 0px;
    border-radius:30px;
    border:1px solid rgba(77,192,233, 0.3);
    padding:30px;
    transition: all 0.5s;
    transform: scale(1.0);
    height:220px;

    &:hover {
        box-shadow: rgba(60, 66, 87, 0.12) 0px 0px 5px 0px, rgba(0, 0, 0, 0.12) 0px 0px 5px 0px;
        margin-top:-8px;

    }
`



const BenefitContents = styled.div`
    display:flex;
    height:inherit;
    flex-direction:column;
    justify-content:flex-start;
    flex-wrap:nowrap;
    align-items:center;
    align-content:center;
    cursor:pointer;
    transition:all 0.5s;
 
`



const BenefitTitle = styled.div`
    font-family: newFontFaceBold, Arial, sans-serif;
    width:100%;
    box-sizing:border-box;
    font-size:17px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    align-content:center;
    text-align:center;
    padding-bottom:20px;
`




const BenefitImages = styled.img`
    display:flex;
    object-fill:contain;
    box-sizing:border-box;
    height:100px;
    padding:0;
    margin:0;
`


const BenefitImage = styled.div`
    padding:10px;
    width:80%;
    display:flex;
    justify-content:center;
    align-items:center;
    align-content:center;
`

const BenefitDescription = styled.div`
    display:flex;
    font-family: newFontFaceLight, Arial, sans-serif;
    justify-content:flex-start;
    text-align:left;
    align-items:center;
    align-content:center;
    font-size:13px;
`      

const BenefitCallOutBox = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    border-radius:10px;
    flex-direction:column;
    padding:20px;
    background: rgba(77, 192, 233, 0.1);
`


const BenefitCallOut = styled.span`
    padding:10px;   
    display:flex;
    font-size:25px;
    font-family: newFontFace, Arial, sans-serif;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:center;
`      

const BenefitCallOutSub = styled.span`
    padding:10px; 
    padding-top:0px;  
    display:flex;
    font-family: newFontFaceLight, Arial, sans-serif;
    justify-content:center;
    align-items:center;
    align-content:center;
    text-align:center;
    font-size:12px;
`      